import type {
	FeedEventType as FeedEventTypeEnum,
	FeedItemSourceType as FeedItemSourceTypeEnum,
} from './__generated__/useFollowingFeedWithSortByStorageFeedContentQuery.graphql.ts';

export const FeedEventType: {
	COMMENT: 'COMMENT';
	CREATE: 'CREATE';
	EDIT: 'EDIT';
	EDITLIVE: 'EDITLIVE';
	PUBLISHLIVE: 'PUBLISHLIVE';
} = {
	COMMENT: 'COMMENT' as const,
	CREATE: 'CREATE' as const,
	EDIT: 'EDIT' as const,
	EDITLIVE: 'EDITLIVE' as const,
	PUBLISHLIVE: 'PUBLISHLIVE' as const,
} satisfies Record<string, FeedEventTypeEnum>;

export const FeedItemSourceType: {
	PERSON: 'PERSON';
	SPACE: 'SPACE';
} = {
	PERSON: 'PERSON' as const,
	SPACE: 'SPACE' as const,
} satisfies Record<string, FeedItemSourceTypeEnum>;
